import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { roleKeys } from './roleKeys';

export function useDeleteRole() {
  const qc = useQueryClient();
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: (roleId: string) => apiClient.delete(`api/v1/t/${tenantId}/roles/${roleId}`).json(),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: roleKeys.lists() });
      qc.invalidateQueries({ queryKey: ['roles', 'list', tenantId] });
    },
  });
}
